<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="map">
<p class="ct"><a class="xref" href="#/OEBPS/Text/pppstrangers005#toc">Map</a></p>
<div class="figure">
<p class="fig"><img alt="" class="calibre5" src="OEBPS/Images/ppp-strangers-map.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-strangers007.vue?7ab8ef56